import { render, staticRenderFns } from "./MultiRegroupModal.vue?vue&type=template&id=37433659&scoped=true&"
import script from "./MultiRegroupModal.vue?vue&type=script&lang=ts&"
export * from "./MultiRegroupModal.vue?vue&type=script&lang=ts&"
import style0 from "./MultiRegroupModal.vue?vue&type=style&index=0&id=37433659&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37433659",
  null
  
)

export default component.exports